
import { Attendance } from '@/types';

// Mock Attendance Records
export const attendance: Attendance[] = [
  {
    id: 'att-1',
    employeeId: 'emp-1',
    date: '2023-04-01',
    checkIn: '09:00:00',
    checkOut: '17:00:00',
    workHours: 8,
    overtime: 0,
    status: 'present'
  },
  {
    id: 'att-2',
    employeeId: 'emp-2',
    date: '2023-04-01',
    checkIn: '08:45:00',
    checkOut: '17:30:00',
    workHours: 8.75,
    overtime: 0.75,
    status: 'present'
  },
  {
    id: 'att-3',
    employeeId: 'emp-3',
    date: '2023-04-01',
    checkIn: null,
    checkOut: null,
    workHours: 0,
    overtime: 0,
    status: 'absent'
  }
];
